import React from 'react'
import './ouroffices.scss'
import {images} from '../../../utils/customFn';
const OurOffices = () => {
  // Reusable Component for each section block
  const TopicContentBlock = ({ title, children }) => (
    <div className="topicContentBlock">
      <div className="Heading">
        <h3>{title}</h3>
      </div>
      <div>{children}</div>
    </div>
  );

  const offices = [
    { id: 1, name: 'Stevens Point, WI', description: 'Sentry home office', img: images['office.avif'] },
    { id: 2, name: 'Madison, WI', description: 'Corporate office', img: images['office.avif']},
    { id: 3, name: 'Chicago, IL', description: 'Regional office', img: images['office.avif']},
    { id: 4, name: 'Chicago, IL', description: 'Regional office', img: images['office.avif']},
    { id: 5, name: 'Chicago, IL', description: 'Regional office', img: images['office.avif']},
    { id: 6, name: 'Chicago, IL', description: 'Regional office', img: images['office.avif']},
    { id: 7, name: 'Chicago, IL', description: 'Regional office', img: images['office.avif']},
    { id: 8, name: 'Chicago, IL', description: 'Regional office', img: images['office.avif']},
    { id: 9, name: 'Chicago, IL', description: 'Regional office', img: images['office.avif']},
    { id: 10, name: 'Chicago, IL', description: 'Regional office', img: images['office.avif']},
  ];

  return (
    <>
      <div className="our-office-wrapper">
        {/* Main Introduction */}
        <TopicContentBlock title="By location">
          <ul className="office-list">
            {offices.map((office) => (
              <li key={office.id}>
                <div className='media'>
                  <img src={office.img} alt='office'/>
                </div>
                <h3>{office.name}</h3>
                <p>{office.description}</p>
              </li>
            ))}
          </ul>
        </TopicContentBlock>
      </div>
    </>
  )
}

export default OurOffices